<template>
  <div>
    <b-navbar
      class="merch-settings-nav"
      toggleable="lg"
      type="light"
      variant="light"
    >
      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav class="nav-elements">
          <b-nav-item
            class="setting-nav"
            href="#"
            @click="showDetails('Company')"
          >
            <p v-if="showModal == 'Company'" style="color:#8888ea">
              Company Settings
            </p>
            <p v-else>Company Settings</p>
          </b-nav-item>

          <b-nav-item
            class="setting-nav"
            href="#"
            @click="showDetails('FAC-settings')"
            ><p v-if="showModal == 'FAC-settings'" style="color:#8888ea">
              FAC Settings
            </p>
            <p v-else>FAC Settings</p></b-nav-item
          >

          <b-nav-item
            class="setting-nav"
            href="#"
            @click="showDetails('Payment')"
          >
            <p v-if="showModal == 'Payment'" style="color:#8888ea">
              Payment Settings
            </p>
            <p v-else>Payment Settings</p>
          </b-nav-item>

          <b-nav-item
            class="setting-nav"
            href="#"
            @click="showDetails('Payment-Button')"
          >
            <p v-if="showModal == 'Payment-Button'" style="color:#8888ea">
              Payment Button Settings
            </p>
            <p v-else>Payment Button Settings</p>
          </b-nav-item>
          <b-nav-item class="setting-nav" href="#" @click="showDetails('API')">
            <p v-if="showModal == 'API'" style="color:#8888ea">
              API Key Settings
            </p>
            <p v-else>API Key Settings</p>
          </b-nav-item>

          <b-nav-item
            class="setting-nav"
            href="#"
            @click="showDetails('WebHooks')"
          >
            <p v-if="showModal == 'WebHooks'" style="color:#8888ea">
              WebHooks
            </p>
            <p v-else>WebHooks</p>
          </b-nav-item>

          <b-nav-item
            class="setting-nav"
            href="#"
            @click="showDetails('EmailNotifications')"
          >
            <p v-if="showModal == 'EmailNotifications'" style="color:#8888ea">
              Email Notifications
            </p>
            <p v-else>Email Notifications</p>
          </b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>

    <div>
      <!--begin: Form Wizard Form-->
      <div>
        <div v-if="showModal == 'Company'">
          <h1 class="setting-title">Company Settings</h1>
          <hr />
          <div>
            <CompanySettings v-if="hasEditMerchantSettingsPermission">
            </CompanySettings>
          </div>
        </div>
      </div>
      <div v-if="showModal == 'FAC-settings'">
        <h1 class="setting-title">FAC Settings</h1>
        <hr />
        <div>
          <FACSettings v-if="hasEditMerchantSettingsPermission"> </FACSettings>
        </div>
      </div>
      <div v-if="showModal == 'Payment'">
        <h1 class="setting-title">Custom Field Settings</h1>
        <hr />
        <div>
          <CustomFieldSettings
            v-if="hasSetCustomFieldsPermission"
          ></CustomFieldSettings>
        </div>
      </div>
      <div v-if="showModal == 'Payment-Button'">
        <h1 class="setting-title">Payment Button Settings</h1>
        <hr />
        <div>
          <PaymentButtonSettings
            v-if="hasEditMerchantSettingsPermission"
          ></PaymentButtonSettings>
        </div>
      </div>

      <div v-if="showModal == 'API'">
        <h1 class="setting-title">API Key Settings</h1>
        <hr />
        <div>
          <ApiKeySettings
            v-if="hasEditMerchantSettingsPermission"
          ></ApiKeySettings>
        </div>
      </div>
      <div v-if="showModal == 'WebHooks'">
        <h1 class="setting-title">Web Hooks Settings</h1>
        <hr />
        <div>
          <WebhooksSettings
            v-if="hasEditMerchantSettingsPermission"
          ></WebhooksSettings>
        </div>
      </div>
      <div v-if="showModal == 'EmailNotifications'">
        <h1 class="setting-title">Email Notification Settings</h1>
        <hr />
        <div>
          <EmailNotificationSettings
            v-if="hasEditMerchantSettingsPermission"
          ></EmailNotificationSettings>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
@import "@/assets/sass/pages/wizard/wizard-2.scss";
</style>

<script>
import { SET_BREADCRUMB } from "@/store/breadcrumbs.module";
import KTUtil from "@/assets/js/util";
import KTWizard from "@/assets/js/wizard";
import Swal from "sweetalert2";
import CompanySettings from "@/views/pages/merchant/settings/CompanySettings";
import FACSettings from "@/views/pages/merchant/settings/FACSettings";
import CustomFieldSettings from "@/views/pages/merchant/settings/CustomFieldSettings";

import PaymentButtonSettings from "@/views/pages/merchant/settings/PaymentButtonSettings";
import ApiKeySettings from "@/views/pages/merchant/settings/ApiKeySettings";
import WebhooksSettings from "@/views/pages/merchant/settings/WebhooksSettings";
import MerchantSettingsPermissionsMixin from "@/components/merchantsettings/MerchantSettingsPermissionsMixin.js";
import EmailNotificationSettings from "@/views/pages/merchant/settings/EmailNotificationSettings";

export default {
  mixins: [MerchantSettingsPermissionsMixin],
  components: {
    CompanySettings,
    FACSettings,
    CustomFieldSettings,
    PaymentButtonSettings,
    ApiKeySettings,
    WebhooksSettings,
    EmailNotificationSettings
  },
  data() {
    return {
      showModal: "Company",
      isActive: false,
      hover: true
    };
  },
  mounted() {
    this.setBreadCrumb("Overview");
    // Initialize form wizard
  },
  methods: {
    submit: function(e) {
      e.preventDefault();
      Swal.fire({
        title: "",
        text: "The application has been successfully submitted!",
        icon: "success",
        confirmButtonClass: "btn btn-secondary"
      });
    },
    setBreadCrumb(currentPage) {
      this.$store.dispatch(SET_BREADCRUMB, [
        { title: "Merchant Settings" },
        { title: currentPage }
      ]);
    },
    showDetails(arg) {
      this.showModal = arg;
      this.isActive = !this.isActive;
    }
  }
};
</script>

<style lang="scss" scoped>
* {
  font-family: "Open Sans", sans-serif;
}

.merch-settings-nav {
  border-color: black;
  border-style: solid;
  min-width: 100%;
  border-width: 1px 0px 1px 0px;
  background-color: white !important;
}

li.setting-nav > a {
  font-weight: normal;
  font-size: 14px;
  margin-right: 10px;
  color: black !important;
}

li.setting-nav > a > * {
  margin-bottom: 0 !important;
}

li.setting-nav > a:hover {
  color: #8888ea !important;
}
.active {
  color: #8888ea !important;
}
.company-settings {
  display: grid !important;
  grid-template-columns: 1.5fr 2fr !important;
}
.setting-title {
  padding-top: 5%;
  padding-left: 5%;
  padding-bottom: 1%;
  font-size: 24px;
}
.brand-logo {
  padding-right: 7%;
}

.brand-logo > div {
  padding-bottom: 0;
}

@media only screen and (min-width: 1024px) {
  .nav-elements {
    min-width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
  }
}

@media only screen and (max-width: 1023px) {
  .company-settings {
    display: flex !important;
    flex-direction: column;
  }
  .brand-logo {
    padding: 0;
  }
}
</style>
